var map = {
	"./basketballTrainingCol.svg": "2357",
	"./dayoffCol.svg": "299b",
	"./holidayCol.svg": "eb52",
	"./matchCol.svg": "a3e5",
	"./meetingCol.svg": "6357",
	"./physicalTrainingCol.svg": "22bf",
	"./travelCol.svg": "ddfc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d85";